import Routes from "~/constants/routes";
import CommonTile from "./CommonTile";
import Table from "~/pages/Journals/BusinessOperations/Table";
import { useTranslation } from "react-i18next";
import { PERMISSION } from "~/api/permissions/enums";
import usePermissions from "~/hook/usePermissions";
import api from "~/api";

const BusinessOperationsWidget = () => {
  const { t } = useTranslation();
  const { hasAll } = usePermissions();

  if (!hasAll(PERMISSION.READ_JOURNAL_BUSINESS_OPERATIONS)) return null;

  const getData = () =>
    api.businessOperationsJournal
      .getBusinessOperations(5, 1, { sort: "-createdAt" })
      .then((res) => res.data.data);

  return (
    <CommonTile
      title={t("title.businessOperations")}
      showAllText={t("button.showAll")}
      onUpdate={getData}
      showAllLink={Routes.BUSINESS_OPERATIONS}
    >
      {(data) => <Table dataSource={data || []} hideSorting={true} />}
    </CommonTile>
  );
};

export default BusinessOperationsWidget;
